(function($) {
  function categoryFilter() {
    function closeDropdowns() {
      $('.goto').find('.links').slideUp();
      $('.goto .trigger').removeClass('open');      
    }
    
    $(document).on('click', '.goto .trigger', function() {
      if ($(this).hasClass('open')) {
        closeDropdowns();
      }
      else {
        closeDropdowns();
        $(this).siblings('.links').slideToggle();
        $(this).toggleClass('open');
      }
    });
    
    $(document).on('click', function(e) {
      var isDropdown = $(e.target).closest('.trigger').length;
      if (!isDropdown) {
        closeDropdowns();
      }
    });    
  }
  
  function faqAccordion() {
    var timer_faq, timer_progress;
    var time_per_faq = 5000;
    
    var faq_index = 1;
    var total_faq = $('.faq-item').length;
    
    timer_faq = setInterval(function() {
      $('.faq-item').removeClass('active');
      if(document.querySelector('.faq-item[data-index="' + faq_index + '"]')){
        document.querySelector('.faq-item[data-index="' + faq_index + '"]').classList.add('active');
      }
      
      faq_index++;
      if (faq_index > total_faq) {
        faq_index = 1;
      }      
    }, time_per_faq);
    
    $(document).on('click', '.faq-item', function(e) {   
      e.preventDefault();
      
      clearInterval(timer_faq);
      clearInterval(timer_progress);
      
      $(e.currentTarget).closest('.faq-list').find('.faq-item').removeClass('active');
      $(e.currentTarget).closest('.faq-item').addClass('active manually-active');
      
      $(e.currentTarget).closest('.faq-item').find('.faq-item-progress').css('height', '100%');

      
    });    
  }
  
  ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  // Begin Collections page product variant select image swap
  ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  

 function addToCartPlp(){
   const atcPlp = document.querySelectorAll('[add-to-cart-plp]')
   atcPlp.forEach(function(element){
     element.addEventListener('click',function(e){
       e.preventDefault()
       let formData = {
        'items': [{
         'id': e.target.getAttribute('variant-id'),
         'quantity': 1,
         "properties" : {
          "Ship date": e.target.getAttribute('data-shipping')
          }         
         }]
       };
       fetch(window.Shopify.routes.root + 'cart/add.js', {
         method: 'POST',
         headers: {
           'Content-Type': 'application/json'
         },
         body: JSON.stringify(formData)
       })
       .then(response => {
        addToCartSuccess();
         return response.json();
       })
       .catch((error) => {
         console.error('Error:', error);
       });       
     })
   })
 }

  ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  // End Collections page product variant select image swap
  ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  
  function initCollection() {
    categoryFilter();
    // faqAccordion();
    // pressCarousels();
    addToCartPlp();
  }
  
  $(document).ready(function() {
    initCollection();
  });
  
  document.addEventListener('shopify:section:load', function (event) {
    initCollection();
  });

  document.addEventListener('shopify:section:unload', function (event) {
    initCollection();
  });  
})(jQuery);

function resizeDebounce(func){
  var timer;
  return function(event){
    if(timer) clearTimeout(timer);
    timer = setTimeout(func,100,event);
  };
}


window.Branch = window.Branch || {};
window.Branch.collection = window.Branch.collection || {};


const isOverflown = ({
	clientWidth,
	clientHeight,
	scrollWidth,
	scrollHeight
}) => (scrollWidth > clientWidth) || (scrollHeight > clientHeight)
const resizeText = ({
	element,
	elements,
	minSize = 10,
	maxSize = 23,
	step = 1,
	unit = 'px'
}) => {
	(elements || [element]).forEach(el => {
		let i = minSize
		let overflow = false
		const parent = el.parentNode
		while (!overflow && i < maxSize) {
			el.style.fontSize = `${i}${unit}`
			overflow = isOverflown(parent)
			if (!overflow) i += step
		}
		el.style.fontSize = `${i - step}${unit}`
	})
}

const reverseChildren = function(parent) {
  for (var i = 1; i < parent.childNodes.length; i++){
      parent.insertBefore(parent.childNodes[i], parent.firstChild);
  }
}

const createNewLayout = function(actualIndex, collectionGrid, imageCard, imageSpacerCard){
  let newDiv = document.createElement("div");
  newDiv.classList.add('image-card__card-tiles-container');
  newDiv.setAttribute('data-index', actualIndex);
  newDiv.insertAdjacentHTML('beforeend', '<div class="image-card__product-tile-wrapper">')
  for (let i = 0; i < 4; i++) {
    let cardIndex = (actualIndex + 1) * 4 - (4 - i);
    let card = document.querySelector(`.collection-section .product-tile[data-index="${cardIndex}"]`);
    if(card){
      newDiv.querySelector('.image-card__product-tile-wrapper').appendChild(card)
      newDiv.appendChild(imageCard)
    }
  }
  
  if (imageSpacerCard) {
    collectionGrid.prepend(imageSpacerCard)
  }
  collectionGrid.prepend(newDiv)
}

const destroyNewLayout = function(collectionContainer, collectionGrid){
  let cardTilesContainers = collectionContainer.querySelectorAll('.image-card__card-tiles-container');
  cardTilesContainers.forEach((ctc, ctcIndex) => {
    let actualCTCIndex = cardTilesContainers.length - 1 - ctcIndex
    let cardTilesContainer = cardTilesContainers[actualCTCIndex];
    let imageCardContainer = cardTilesContainer.querySelector('.image-card__container')
    if(imageCardContainer != null){
      collectionGrid.prepend(imageCardContainer);

    }
    let cardTiles = cardTilesContainer.querySelectorAll('.product-tile');
    cardTiles.forEach((ct, ctIndex) => {
      let actualCTIndex = cardTiles.length - 1 - ctIndex
      let cardTile = cardTiles[actualCTIndex]
      if(cardTile != null){
        collectionGrid.prepend(cardTile)
      }
    })
    cardTilesContainer.remove();

  })
  collectionContainer.setAttribute('data-image-card-elements-moved', 'false')
}

window.Branch.collection.imageCardStyling = function(width, event, detailsHeight, shownHeightAmount, isBottomRow, opening, cardImageIndex){
  let imageCards = document.querySelectorAll(`.collection-section .image-card__container`);
  let imageSpacerCards = document.querySelectorAll(`.collection-section .image-card__spacer`);
  let collectionContainer = document.querySelector(`.collection-section .products--list`);
  let collectionGrid = collectionContainer.querySelector('.grid')
  let detailsShownAll = collectionGrid.querySelectorAll('.product-tile__expandable-details-shown');
  if(detailsShownAll.length > 0){
    detailsShownAll.forEach((detailsShown) => {
      detailsShown.style.removeProperty("min-height");
    })
  }
  if(imageCards.length > 0){
    imageCards.forEach((ic, index) => {
      let actualIndex = imageCards.length - 1 - index
      let imageCard = imageCards[actualIndex]
      let imageSpacerCard = imageSpacerCards[actualIndex] || null
      if(width >= 900){
        if(width >= 1024){
          if(collectionContainer.getAttribute('data-image-card-elements-moved') == 'false'){
            createNewLayout(actualIndex, collectionGrid, imageCard, imageSpacerCard)
          }
          let bottomRefGridItem1 = document.querySelector(`.collection-section .product-tile[data-index="${actualIndex == 0 ? 2 : ((actualIndex * 4) + 2)}"]`);
          let bottomRefGridItem2 = document.querySelector(`.collection-section .product-tile[data-index="${actualIndex == 0 ? 3 : ((actualIndex * 4) + 3)}"]`);
          let hiddenHeight = [];
          let shownHeight = [];
          if(bottomRefGridItem1){
            hiddenHeight.push(parseInt(window.Branch.functions.getStyle(bottomRefGridItem1.querySelector('.product-tile__expandable-details-hidden'), "height").replace('px', '')));
            shownHeight.push(parseInt(window.Branch.functions.getStyle(bottomRefGridItem1.querySelector('.product-tile__expandable-details-shown'), "height").replace('px', '')))
          }
          if(bottomRefGridItem2){
            hiddenHeight.push(parseInt(window.Branch.functions.getStyle(bottomRefGridItem2.querySelector('.product-tile__expandable-details-hidden'), "height").replace('px', '')));
            shownHeight.push(parseInt(window.Branch.functions.getStyle(bottomRefGridItem2.querySelector('.product-tile__expandable-details-shown'), "height").replace('px', '')))
          }
          
          shownHeight.sort(function(a, b) {
              return a - b;
          }).reverse();

          let heightArray = [];
          if(hiddenHeight.length > 0){
            bottomRefGridItem1.querySelector('.product-tile__expandable-details-shown').style.height = `${shownHeight[0]}px`;
            heightArray.push(parseInt(hiddenHeight[0] + shownHeight[0]))
          }

          if(hiddenHeight.length > 1){
            heightArray.push(parseInt(hiddenHeight[1] + shownHeight[1]))
            bottomRefGridItem2.querySelector('.product-tile__expandable-details-shown').style.height = `${shownHeight[0]}px`;
          }

          heightArray.sort(function(a, b) {
              return a - b;
          }).reverse();

          if(heightArray.length > 0){
            if(isBottomRow && isBottomRow == true && actualIndex == cardImageIndex){
              if(opening == true){
                imageCard.style.height = `calc(100% - ${detailsHeight}px - ${shownHeightAmount}px - 14px - 25px)`;
              } else {
                imageCard.style.height = `calc(100% - 14px - 25px - ${shownHeight[0]}px)`;
              }
            } else {
              imageCard.style.height = `calc(100% - 14px - 25px - ${heightArray[0]}px)`;
            }
          }
          
          if((index + 1) == imageCards.length){
            collectionContainer.setAttribute('data-image-card-elements-moved', 'true')
          }
        } else {
          if(collectionContainer.getAttribute('data-image-card-elements-moved') == 'true'){
            destroyNewLayout(collectionContainer, collectionGrid)
          }
         imageCard.style.removeProperty('height');
        }
      } else {
        if(collectionContainer.getAttribute('data-image-card-elements-moved') == 'true'){
          destroyNewLayout(collectionContainer, collectionGrid)
        }
        imageCard.style.removeProperty('height');
      }
    })
  }
  if(collectionContainer && collectionContainer.hasAttribute('data-loaded') && collectionContainer.getAttribute('data-loaded') == "false"){
    collectionContainer.setAttribute('data-loaded', 'true')
  }
}

window.Branch.collection.infoCardStyling = function(event) {
	const width = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
	const infoCard = document.querySelector('.info-card');
	if (infoCard) {
		let position = parseInt(infoCard.getAttribute('data-position'));
		if (width < 600) {
      let slides = infoCard.querySelectorAll('.info-card__content');
      let maxContentHeight = 0;
      slides.forEach((slide) => {
        let textHeight = slide.querySelector('p').offsetHeight;
        let imageHeight = slide.querySelector('img') ? slide.querySelector('img').offsetHeight : 0;
        let combinedHeight = textHeight + imageHeight;
        if(combinedHeight > maxContentHeight){
          maxContentHeight = combinedHeight;
        }
      })

      infoCard.style.height = `${maxContentHeight + 300}px`;
      infoCard.querySelectorAll('.info-card__content').forEach((infoCardContent) => {
        let textHeight = infoCardContent.querySelector('p').offsetHeight;
        let imageHeight = infoCardContent.querySelector('img') ? infoCardContent.querySelector('img').offsetHeight : 0;
        let addedToTop = imageHeight > 0 ? 24 : 0;
        let difference = ((infoCardContent.querySelector('.info-card__quote').offsetHeight - textHeight) / 2);

        infoCardContent.querySelector('.info-card-apostrophe-1').style.top = `${56 + addedToTop + imageHeight + difference - 50}px`;
        infoCardContent.querySelector('.info-card-apostrophe-2').style.top = `${56 + addedToTop + imageHeight + textHeight + difference - 20}px`;
        infoCardContent.querySelector('.info-card-apostrophe-1').style.opacity = 1;
        infoCardContent.querySelector('.info-card-apostrophe-2').style.opacity = 1;
      });
      
		} else {
			if (width > 599 && width < 900) {
				let positionInRow = 2 - (position % 2);
				let productGridItems = document.querySelectorAll('.products--list .product-tile');
				let sibling = positionInRow == 1 ? productGridItems[position - 1] : productGridItems[position - 2];
				if (sibling) {
          let siblingHeight = parseFloat(window.Branch.functions.getStyle(sibling, 'height').replace('px', ''));
          infoCard.style.height = `${siblingHeight}px`;
				}
			} else {
				let positionInRow = (position % 3);
				let productGridItems = document.querySelectorAll('.products--list .product-tile');
				let siblings = [];
				if (positionInRow == 1) {
					siblings.push(productGridItems[position], productGridItems[position + 1])
				} else if (positionInRow == 2) {
					siblings.push(productGridItems[position], productGridItems[position - 2])
				} else {
					siblings.push(productGridItems[position - 2], productGridItems[position - 3])
				};
				siblings = siblings.filter(Boolean);

				if (siblings.length > 0) {
					let tallestSiblingHeight = null;
          let spaceUnderShopNow = null;
					siblings.forEach((sibling) => {
						let siblingHeight = parseFloat(window.Branch.functions.getStyle(sibling, 'height').replace('px', ''));
            let siblingSpaceUnderShopNow = parseFloat(window.Branch.functions.getStyle(sibling.querySelector('.product-tile__swatches-container'), 'height').replace('px', '')) - 50;
            if(siblingHeight > tallestSiblingHeight || tallestSiblingHeight == null){
              tallestSiblingHeight = siblingHeight
              spaceUnderShopNow = siblingSpaceUnderShopNow
            }
         });

					infoCard.style.height = `${tallestSiblingHeight - spaceUnderShopNow}px`;
				}
			}
      resizeText({
        elements: document.querySelectorAll('.info-card__content p'),
        step: 0.25
      });
      let infoCardSlides = infoCard.querySelectorAll('.swiper-slide');
      if(infoCardSlides.length > 0){
      var height = parseFloat(window.Branch.functions.getStyle(infoCardSlides[0], 'height').replace('px', ''));
        infoCardSlides.forEach((infoCardSlide) => {
          var elDistanceToTop = (infoCardSlide.querySelector('p').getBoundingClientRect().top) - (infoCardSlide.getBoundingClientRect().top);
          var elDistanceToBottom = (infoCardSlide.querySelector('p').getBoundingClientRect().bottom) - (infoCardSlide.getBoundingClientRect().bottom);
          infoCardSlide.querySelector('.info-card-apostrophe-1').style.top = `${elDistanceToTop - 63.4}px`;
          infoCardSlide.querySelector('.info-card-apostrophe-2').style.top = `${height + elDistanceToBottom}px`;
          infoCardSlide.querySelector('.info-card-apostrophe-1').style.opacity = `1`;
          infoCardSlide.querySelector('.info-card-apostrophe-2').style.opacity = `1`;
        })
      }
      
    }
	}
}
const initInfoCardStyling = function() {
	window.Branch.collection.infoCardStyling("onLoad");
}

let productsList = document.querySelector('.products--list.page-container');

const fourProductsAndImageCardSectionOnResize = function (onLoad){
  document.querySelectorAll('.collection-four-products-and-image-card').forEach((fourProductsSection) => {
    let newLayout = window.innerWidth < 900 ? 'mobile' : window.innerWidth > 1023 ? 'large-desktop' : 'desktop';
    let currentLayout = fourProductsSection.getAttribute('data-current-layout');
    

    let finalGridItem = fourProductsSection.querySelector('.product-tile[data-index="0"]');
    let standIn = fourProductsSection.querySelector('.collection-four-products-and-image-card__small-desktop-loading-stand-in');
    let imageCardContainer = fourProductsSection.querySelector('.collection-four-products-and-image-card__image-card-container');
    let gridContainer = fourProductsSection.querySelector('.collection-four-products-and-image-card__grid-container');

    console.log('currentLayout', currentLayout)

    if(newLayout != currentLayout || onLoad == true){
      fourProductsSection.setAttribute('data-transitioning', true);

      if(newLayout == 'desktop' || onLoad == true && currentLayout == 'desktop' ){
        imageCardContainer.append(finalGridItem);
        gridContainer.prepend(standIn)
      } else {
        imageCardContainer.append(standIn);
        gridContainer.querySelector('.grid').prepend(finalGridItem)
      }

      fourProductsSection.setAttribute('data-current-layout', newLayout);
      fourProductsSection.setAttribute('data-transitioning', false);
    }

    imageCardContainer.querySelector('.image-card__container').style.removeProperty('height');
    if(newLayout == 'large-desktop'){
      let gridHeight = gridContainer.offsetHeight;
      imageCardContainer.querySelector('.image-card__container').style.height = `${gridHeight}px`
    } else if(newLayout == 'desktop'){
      let gridHeight = finalGridItem.offsetHeight;
      imageCardContainer.querySelector('.image-card__container').style.height = `${gridHeight}px`
    } 
  });
}

const fourProductsAndImageCardSectionInit = function(){
  document.querySelectorAll('.collection-four-products-and-image-card').forEach((fourProductsSection) => {
    let currentLayout = window.innerWidth < 900 ? 'mobile' : window.innerWidth > 1023 ? 'large-desktop' : 'desktop';
    fourProductsSection.setAttribute('data-current-layout', currentLayout);
    fourProductsAndImageCardSectionOnResize(true)
  })
}

const initImageCardStyling = function(width){
  if(productsList && productsList.hasAttribute('data-image-card-elements-moved')){
    window.Branch.collection.imageCardStyling(width, "onLoad")
  }
}

var fourProductsAndImageCardSectionsPresent = document.querySelectorAll('.collection-four-products-and-image-card').length > 0;

const customFeatureImageHeightAdjust = function(){
  document.querySelectorAll('.custom-feature-image:not([data-bfcm="true"])').forEach((featureImage) => {
    if(featureImage.querySelector(`.custom-feature-image__image-container[data-mobile-image="false"]`)){
      let titleSubtitleCombinedHeight = featureImage.querySelector('.custom-feature-image__text-cta-container ').offsetHeight + 24 + 24;
      let sectionHeight = featureImage.querySelector('.custom-feature-image__image-container ').offsetHeight;
      if(window.innerWidth < 600){
        if(titleSubtitleCombinedHeight > sectionHeight){
          featureImage.querySelector('.custom-feature-image__image-container').style.height = `${titleSubtitleCombinedHeight}px`;
        } else {
          featureImage.querySelector('.custom-feature-image__image-container').style.removeProperty('height');
        }
      } else {
        featureImage.querySelector('.custom-feature-image__image-container').style.removeProperty('height');
      }
    }
  })
}

  window.addEventListener("load", function() {
    initInfoCardStyling();
    customFeatureImageHeightAdjust();
  }
  );
  window.addEventListener("load", function() {
    initImageCardStyling(window.innerWidth)
    window.Branch.collection.updateAllBundleBuilderGridTiles('product-tile', '.product-tile');

    /* For four products and image card section */

    if(fourProductsAndImageCardSectionsPresent == true){
      fourProductsAndImageCardSectionInit()
    }
  });

  

	window.addEventListener("resize", resizeDebounce(() => {
    window.Branch.collection.infoCardStyling("onResize")
    customFeatureImageHeightAdjust();
  }));
  
  window.addEventListener("resize", resizeDebounce(function(){
    if(productsList && productsList.hasAttribute('data-image-card-elements-moved')){
      window.Branch.collection.imageCardStyling(window.innerWidth, "onResize")
    }

    if(fourProductsAndImageCardSectionsPresent == true){
      fourProductsAndImageCardSectionOnResize();
    }
  } ));

